import './spinner.css';

export default function Spinner({heights}) {
  return (
    <div className="loader" style={{height: heights, width: heights}}></div>
  )
}
